import classNames from "classnames";
import { useAddBookmarkModal } from "@/react/components/Modals/AddBookmarkModal";
import { DeleteBookmarkConfirmation } from "@/react/components/Spaces/Bookmarks/DeleteBookmarkConfirmation";
import { useBoolean } from "@/react/hooks/utils/useBoolean";
import type { TippyV2Props } from "@circle-react-shared/TippyV2";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { BookmarkTippyContent } from "../BookmarkTippyContent";
import { useSortableBookmarkContext } from "../context/SortableBookmark";
import { LinkBookmarkView } from "./LinkBookmarkView";

export interface LinkBookmarkProps {
  bookmark: any;
  isInsideFolder?: boolean;
  tippyPlacement?: TippyV2Props["placement"];
}

export const LinkBookmark = ({
  bookmark,
  tippyPlacement = "top",
  isInsideFolder = false,
}: LinkBookmarkProps) => {
  const { space } = useSortableBookmarkContext();
  const bookmarkModal = useAddBookmarkModal();
  const [shouldShowDeleteConfirmation, toggleDeleteConfirmation] =
    useBoolean(false);

  return (
    <>
      <TippyV2
        interactive={false}
        content={<BookmarkTippyContent bookmark={bookmark} />}
        arrow
        animation="fade"
        placement={tippyPlacement}
        touch={false}
      >
        <LinkBookmarkView
          space={space}
          bookmark={bookmark}
          isInsideFolder={isInsideFolder}
          onEditClick={() => {
            void bookmarkModal.show({
              space: space,
              isEdit: true,
              bookmark,
              isFolder: false,
            });
          }}
          onDeleteClick={() => {
            toggleDeleteConfirmation();
          }}
          className={classNames({
            "!p-0": isInsideFolder,
          })}
        />
      </TippyV2>
      <DeleteBookmarkConfirmation
        space={space}
        bookmark={bookmark}
        isOpen={shouldShowDeleteConfirmation}
        onClose={toggleDeleteConfirmation}
      />
    </>
  );
};
